import routes from '@/modules/tax-category/tax-category-routes';
import store from '@/modules/tax-category/tax-category-store';

export default {
    routes,
    store,
}
